import BaseEmptyApi from './BaseEmptyApi';

class EmptyService {
    
    static get(url: any) {
        return BaseEmptyApi.get(url);
    }

}

export default EmptyService;